import 'firebase/auth'

import {
  axiosRequestMiddleware,
  axiosResponseMiddleware,
  buildVersion as cpBuildVersion,
  trackAutoLogoutFromCommunities,
} from '@ghl/clientportal-core'

import config from '@/config'
import { useGlobalStore } from '@/store/app'
import { Capacitor } from '@capacitor/core'
import { isGokollab } from '@ghl/clientportal-core/init'
import axios from 'axios'

const isNotGroupDependent = () => {
  return !isGokollab() || window.location.pathname.includes('communities/users')
}
const getHeader = () => {
  const headers = {
    channel: 'APP',
    source: 'PORTAL_USER',
    version: '2023-02-21',
    'x-app-version': import.meta.env.VITE_APP_LOADER || 'web',
    'x-app-build': `communities-${__APP_BUILD_NUMBER__}`,
    'x-cp-core-version': cpBuildVersion,
    'x-platform-details': Capacitor.getPlatform() || null,
  }
  return headers
}
declare global {
  interface Window {
    $cookies: any
  }
}

export const requests = (host?: string) => {
  const baseUrl = host || config.REST_API_URLS
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: getHeader(),
  })

  axiosInstance.interceptors.request.use(async (requestConfig: any) => {
    try {
      requestConfig = await axiosRequestMiddleware(requestConfig)
      requestConfig.headers.source = 'PORTAL_USER'
      const appStore = useGlobalStore()

      if (!requestConfig.headers['x-location-id']) {
        requestConfig.headers['x-location-id'] = appStore.$state.locationId
      }

      if (!isNotGroupDependent()) {
        const { GroupState } = await import('@/composition/groups')
        requestConfig.headers['x-group-id'] = GroupState?.state?.groupData?._id
      }

      if (requestConfig.url.includes('leaderboard')) {
        requestConfig.baseURL = requestConfig.baseURL.replace(
          '/clientclub/v2',
          '/clientclub/'
        )
      }

      return requestConfig
    } catch (e) {
      console.error(e)
    }
    return requestConfig
  })

  // Client Portal Response Middleware
  if (!isGokollab()) {
    axiosResponseMiddleware(axiosInstance)
  } else {
    //GoKollab Frontend Response Middleware
    axiosInstance.interceptors.response.use(
      function handleSuccess(res) {
        if (!isGokollab()) {
          return res
        }

        //For Gokollab Communities - Redirect to Discovery Page if no groups are found
        if (
          res.config?.baseURL?.includes('/gokollab/communities') &&
          res.config?.url?.endsWith('/groups') &&
          res.data?.length === 0 &&
          (window.location.pathname === '/communities/' ||
            window.location.pathname === '/')
        ) {
          window.location.href = `/discovery`
        }

        return res
      },
      async function handleError(error) {
        if (error.config && error.response && error.response.status === 401) {
          trackAutoLogoutFromCommunities('got 401 from gokollab communities', {
            data: error.response.data,
            route: error.config.url,
          })
          //   await logoutUser(false)
          // window.location.reload()
        }

        return Promise.reject(error)
      }
    )
  }

  // axiosInstance.interceptors.response.use(
  //   function handleSuccess(res) {
  //     return res
  //   },
  //   async function handleError(error) {
  //     if (error.config && error.response && error.response.status === 401) {
  //       await logoutUser(false)
  //       window.location.reload()
  //     }

  //     return Promise.reject(error)
  //   }
  // )
  return axiosInstance
}
